import { React, useState, useEffect, useContext, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import editImg from "../../../assets/img/icon/edit.svg";
import deleteImg from "../../../assets/img/icon/delete.svg";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactSwitch from "react-switch";
import * as SwitchProps from "../../../component/utilities/ReactSwitchReactSwitchProps";
import JoditEditor from "jodit-react";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import parse from "html-react-parser";

function QuestionCommentList() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});
  const [processing, setProcessing] = useState(false);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [questionId, setQuestionId] = useState(0);
  const MySwal = withReactContent(Swal);
  const [listLimit, setListLimit] = useState(50);

  const [action, setAction] = useState("");
  const [replyList,setReplyList] =  useState("");


  /** For Modalpopup */
  const [show, setShow] = useState(false);
  const [addReplyPopupShow, setAddReplyPopupShow] = useState(false);
  const [listReplyPopupShow, setListReplyPopupShow] = useState(false);
  

  /* START DATATABLE */
  const [totalRecords, settotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);

  //Search
  const [searchQuestionStatus, setsearchQuestionStatus] = useState("");
  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const pageNumberLimit = { perPage };
 
  //reply pagination
  const [replyActivePage, setReplyActivePage] = useState(1);
  //Search reply
  const [replyDataSort, setReplyDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const [replyPerPage, setReplyPerPage] = useState(10);

  //For Form
  const [questionTitle, setQuestionTitle] = useState("");
  const [techDescription, setDescription] = useState("");
  const [status, setStatus] = useState(false);
  const [allTechVersions, setAllTechVersions] = useState([]);
  const [techName, setTechName] = useState("");
  const [dbVersionValue, setDbVersionValue] = useState("");
  const [commentStatus, setCommentStatus] = useState("");
  const [commentId, setCommentId] = useState("");
  const [versionId, setVersionId] = useState("");
  const [commentReply,setCommentReply] = useState("");

  const editor = useRef(null);

  const config = useMemo(
      () => ({
        readonly: false,
        uploader: { "insertImageAsBase64URI": true },
        toolbarButtonSize: 'medium',
        toolbarSticky: false,
        buttons: [
          "bold",
          "italic",
          "underline",
          "|", // separator
          "align", "ul", "ol", "|",
          "|", "undo", "redo",
        ],
      }),
      []
    );

  const params = useParams();
  let technologyId = params.techId;
  let questnId = params.id;
  let id = params.id;

  let isToken = "";
  let userId = "";
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      userId = authUserData[0].user_id ? authUserData[0].user_id : "";
    }
  }

  const [searchParam, setSearchParam] = useState({
    srchStatus: searchQuestionStatus,
    srchEmail:""
  });

  useEffect(() => {
    fetchTechnologyById(id);
    fetchQuestionById(questnId);
    
    getVersions();
  }, [searchParam, dataSort, activePage, listLimit]);

  async function getVersions() {
    let apiUrl = CONST.GET_TECHNOLOGY_VERSIONS + `${id}`;
    let strMethod = "put";
    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          let versionDetails = response.data.data;
          let optionsVersion = versionDetails.map((v, index) => ({
            label: v.version,
            value: v.version,
          }));
          setAllTechVersions(optionsVersion);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  function showListReplyPopupShow(commentId){
    setListReplyPopupShow(true);
    fetchCommentsReply(commentId,replyPerPage,replyActivePage,replyDataSort );
  }
     //fetch all technology details
  async function fetchCommentsReply(
    commentId,paramLimit,paramPage,paramSort    
     ){
    setLoading(true);
    await axios
      .post(
        CONST.GET_COMMENTS_REPLY_LIST,
        {
          comment_id: commentId,
          limit: paramLimit,
          page_number: paramPage,
          sort: paramSort,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
           setReplyList(response.data.data);
          // setTotalRows(response.data.count);
          // settotalRecords(response.data.count);
        } else {
          toast.error(response.data.message);
          setReplyList("");
        }
      })
      .catch((error) => {});
      setLoading(false);
    }

  const closeListReplyPopup = () => {
    setListReplyPopupShow(false);
  }

  function showAddReplyPopup(commentId,techId,versionId){
    setCommentId(commentId);
    setVersionId(versionId);
    setAddReplyPopupShow(true);
  }

  const closeReplyPopup = () => {
    setCommentReply("");
    setCommentId("");
    setVersionId("");
    setAddReplyPopupShow(false);
  };

  // function handleShow(action, questionId) {
  //   const question_id = questionId ? questionId : 0;
  //   setQuestionId(question_id);
  //   setQuestionTitle("");
  //   setStatus("");
  //   setVersionValue("");
  //   setDbVersionValue("");
  //   setDescription("");

  //   if (question_id !== 0) {
  //     fetchQuestionById(question_id);
  //   }
  //   setAction(action);
  //   setShow(true);
  // }

  async function questionSearch() {
    setSearchParam({
      srchStatus: searchQuestionStatus,
      srchEmail:""
    });

    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  }

  function clearSearch() {
    setsearchQuestionStatus("");
    setSearchParam({
      srchStatus: "",
      srchEmail:""
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  }

  const [versionValue, setVersionValue] = useState("");
  const handleOnchange = (version_id) => {
    setVersionValue(version_id);
    fetchQuestionsComments(searchParam, dataSort, activePage, perPage, technologyId,questnId,version_id);
  };

  const handleClose = () => {
    setShow(false);
    setQuestionId(0);
    setQuestionTitle("");
    setStatus("");
  };

  function deleteHandler(questionId, technologyId) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Question?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        if (questionId > 0) {
          setLoading(true);
          axios
            .delete(CONST.DELETE_QUESTION_DETAILS, {
              headers: {
                Authorization: `Bearer ${isToken}`,
              },
              data: {
                technology_id: technologyId,
                question_id: questionId,
              },
            })
            .then((response) => {
              if (response) {
                if (response.data.status == "error") {
                  toast.error(response.data.message);
                } else {
                  toast.success(response.data.message);
                  fetchQuestionsComments(
                    searchParam,
                    dataSort,
                    activePage,
                    perPage,
                    id
                  );
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Something went wrong. Please try again." + error);
            });
          setLoading(false);
        }
      }
    });
  }

  //fetch all Technology data by id
  async function fetchTechnologyById(technologyId) {
    setLoading(true);
    let apiUrl = CONST.GET_TECHNOLOGY_BY_ID + `${technologyId}`;
    let strMethod = "put";
    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;

        if (status === "success") {
          let technologyData = response.data.data ? response.data.data : [];

          setTechName(technologyData["name"]);
        }
      })
      .catch((error) => {
        alert(error);
      });
    setLoading(false);
  }

  //fetch all Question data by id
  async function fetchQuestionById(questnId) {
    setLoading(true);
    let apiUrl = CONST.GET_QUESTION_BY_ID + `${questnId}`;
    let strMethod = "put";

    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;

        if (status === "success") {
          let questionData = response.data.data ? response.data.data : [];
          let arrVersion = questionData["e_question_has_versions"]
            ? questionData["e_question_has_versions"].map((v, index) => ({
              id: v.id,
              value: v.version_id,
            }))
            : "";

          setDbVersionValue(arrVersion);
          setVersionValue(arrVersion.toString());

          setQuestionTitle(questionData["title"] ? questionData["title"] : "");
          setDescription(
            questionData["description"] ? questionData["description"] : ""
          );
          setStatus(questionData["status"] ? questionData["status"] : "");
        }
      })
      .catch((error) => {
        alert(error);
      });
    setLoading(false);
  }

  //fetch all technology details
  async function fetchQuestionsComments(
    paramSearch,
    paramSort,
    paramPage,
    paramLimit,
    techId,questnId,version_id
  ) {
    //fetchQuestionsComments(searchParam, dataSort, activePage, perPage, technologyId,questnId,version_id);
    setLoading(true);
    await axios
      .post(
        CONST.GET_QUESTION_COMMENT_LIST,
        {
          technology_id: techId,
          question_id:questnId,
          version_id:version_id,
          limit: paramLimit,
          search_input: paramSearch,
          page_number: paramPage,
          sort: paramSort,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setData(response.data.data);
          setTotalRows(response.data.count);
          settotalRecords(response.data.count);
        } else {
          toast.error(response.data.message);
          setData(response.data.data);
          setData("");
          setTotalRows(0);
          settotalRecords(0);
        }
      })
      .catch((error) => {});
    setLoading(false);
  }

  
  const submitReply = async (e) => {
    e.preventDefault();
    let isValid = true;

    let validator = Form.validator({
      commentReply: {
        value: commentReply,
        isRequired: true,
        label: "Comment Reply",
      },
    });

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    }

    if (isValid) {
      let apiUrl = "";
      let sucessMessage = "";
      let strMethod = "";

      if (questionId == 0) {
        apiUrl = CONST.ADD_COMMENT_REPLY;
        strMethod = "post";
        sucessMessage = "Reply added succesfully";
      }

      await axios({
        method: strMethod,
        url: apiUrl,
        data: {
          technology_id: technologyId,
          question_id: questnId,
          version_id:versionId ,
          comment_id: commentId,
          reply: commentReply,
          user_id:userId,
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status == "error") {
              toast.error("Something went wrong. Please try again.");
            } else {
              toast.success(sucessMessage);
              closeReplyPopup();
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Something went wrong. Please try again.");
        });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let arrDifference = "";

    let validator = Form.validator({
      allTechVersions: {
        value: allTechVersions,
        isRequired: true,
        label: "Question version",
      },
      questionTitle: {
        value: questionTitle,
        isRequired: true,
        label: "Question",
      },
      techDescription: {
        value: techDescription,
        isRequired: true,
        label: "Description",
      },
    });

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    }

    if (isValid) {
      let apiUrl = "";
      let sucessMessage = "";
      let strMethod = "";

      if (questionId == 0) {
        apiUrl = CONST.ADD_QUESTION;
        strMethod = "post";
        sucessMessage = "Question added succesfully";
      } else {
        apiUrl = CONST.UPDATE_QUESTION;
        strMethod = "post";
        sucessMessage = "Question updated succesfully";
      }

      var strUpdatedValue = versionValue.split(",");

      if (dbVersionValue !== "") {
        arrDifference = dbVersionValue.filter(
          (i) => strUpdatedValue.indexOf(i) === -1
        );
        arrDifference = arrDifference.toString();
      }
      await axios({
        method: strMethod,
        url: apiUrl,
        data: {
          technology_id: id,
          question_id: questionId,
          title: questionTitle,
          version_id: [versionValue],
          description: techDescription,
          status: status == "1" || status == "" ? "1" : "0",
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status == "error") {
              toast.error("Something went wrong. Please try again.");
            } else {
              toast.success(sucessMessage);
              fetchQuestionsComments(
                searchParam,
                dataSort,
                activePage,
                perPage,
                id
              );
              handleClose();
              if (arrDifference.length > 0 && questionId > 0) {
                let apiUrl = CONST.DELETE_TECH_QUESTION_VERSIONS;
                let strMethod = "delete";
                axios({
                  method: strMethod,
                  url: apiUrl,
                  data: {
                    question_id: questionId,
                    version_id: [arrDifference],
                  },
                  headers: {
                    Authorization: `Bearer ${isToken}`,
                  },
                })
                  .then((response) => {
                    const status = response.data.status;
                    if (status == "success") {
                      fetchQuestionsComments(
                        searchParam,
                        dataSort,
                        activePage,
                        perPage,
                        id
                      );
                      //console.log(response.data.message);
                    } else {
                      //console.log(response.data.message);
                    }
                  })
                  .catch((error) => {
                    toast.error("There was an error.");
                  });
              }
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Something went wrong. Please try again.");
        });
    }
  };
  const handleOnStatusChange = (index,approve_status,comment_id,version_id) => {
      axios
      .post(
        CONST.UPDATE_COMMENT_STATUS,
        {
          comment_id : comment_id,
          is_approve : approve_status,
        },
        {
          headers: {
            Authorization: `Basic ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status == "success") {
          toast.success(response.data.message);
          fetchQuestionsComments(searchParam, dataSort, activePage, perPage, technologyId,questnId,version_id);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error("There was an error.");
      });
    // setLoading(false);
    // const newData = [...data];
    // newData[index].status = approve_status;
    // setData(newData);
  }

  const handleChangeStatus = (index, status_value, comment_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(
            CONST.UPDATE_COMMENT_STATUS,
            {
              comment_id: comment_id,
              is_approve: status_value == "0" ? "1" : "0",
            },
            {
              headers: {
                Authorization: `Basic ${isToken}`,
              },
            }
          )
          .then((response) => {
            const status = response.data.status;
            if (status == "success") {
              toast.success(response.data.message);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            toast.error("There was an error.");
          });
        setLoading(false);

        const newData = [...data];
        newData[index].status = status_value == 0 ? 1 : 0;
        setData(newData);
      }
    });
  };

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "5%",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "15%",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      width: "15%",
    },
    {
      name: "Comment",
      selector: (row) => row.comment,
      width: "20%",
    },
    {
      name: "Is Guest User",
      selector: (row) =>  row.is_guest_user,
      width: "5%",
    },
    { 
      name: "Status",
      selector: (row,index) =>  
      <select
        className="form-select form-control"
        name="commentStatus"
        id="commentStatus"
        placeholder="Select status"
        onChange={(e) =>
          handleOnStatusChange(index,e.target.value, row.id,row.version_id)
        }
        value={row.is_approve} >
        <option value="">Select</option>
        <option value="0">Pending</option>
        <option value="1">Approved</option>
        <option value="2">Rejected</option>
      </select>,
      width: "5%",
    },
    {
      name: "Action",
      width: "20%",
      wrap: true,
      sortable: false,
      cell: (row) => <Action row={row} />,
    },
  ];

  const Action = ({ row }) => (
    <>
      {/* <Link
        to={"#"}
        data-id={row.id}
        onClick={() => handleShow("Edit", row.id)}
      >
        <img src={editImg} alt="editUser" width={32} className="cursor" />
      </Link>
      <Link onClick={() => deleteHandler(row.id, row.technology_id)}>
        <img src={deleteImg} alt="deleteImg" width={32} className="cursor" />
      </Link> */}
      <button class="btn btn-primary mr-2" onClick={() =>showAddReplyPopup(row.id,row.technology_id,row.version_id)}><svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 5l0 14"></path><path d="M5 12l14 0"></path></svg>
        Add reply </button>
      <button class="btn btn-primary mr-2" onClick={() =>showListReplyPopupShow(row.id,row.technology_id,row.version_id)}><svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path><path d="M13.1 17.936a9.28 9.28 0 0 1 -1.1 .064c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path><path d="M19 16l-2 3h4l-2 3"></path></svg>Show reply </button>
    </>
  );

  const handleSort = async (column, sortDirection) => {
    setActivePage(1);
    setSearchParam({
      srchStatus: "",
      srchEmail:""
    });

    setDataSort({
      order: sortDirection,
      order_by: column.sortField,
    });
    /*  setLoading(false); */
  };
  /*  PAGINATION FUNCTIONS  */
  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };

  const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    onChangeRowsPerPage, // available but not used here
    currentPage,
  }) => {
    function toPages(pages) {
      const results = [];
      for (let i = 1; i <= pages; i++) {
        results.push(i);
      }
      return results;
    }
    function getNumberOfPages(rowCount, rowsPerPage) {
      return Math.ceil(rowCount / rowsPerPage);
    }

    const handleBackButtonClick = async () => {
      if ((currentPage - 1) % pageNumberLimit === 0) {
        setMaxPageLimit(maxPageLimit - pageNumberLimit);
        setMinPageLimit(minPageLimit - pageNumberLimit);
      }
      onChangePage(currentPage - 1);
    };

    const handleNextButtonClick = async () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + pageNumberLimit);
        setMinPageLimit(minPageLimit + pageNumberLimit);
      }

      onChangePage(currentPage + 1);
    };

    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };

    let paginationText = "Page:  " + currentPage + ", Showing ";

    paginationText =
      paginationText +
      ((currentPage - 1) * perPage + 1) +
      " to " +
      perPage * currentPage;
    paginationText = paginationText + " of " + rowCount + " entries;";

    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li
            key={page}
            id={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className={`page-link ${currentPage === page ? "active" : ""}`}
              onClick={handlePageNumber}
              value={page}
            >
              {page}
            </button>
          </li>
        );
      } else {
        return null;
      }
    });
    let pageIncrementEllipses = null;
    if (pageItems.length > maxPageLimit) {
      pageIncrementEllipses = (
        <li className="page-item" onClick={handleNextButtonClick}>
          &hellip;
        </li>
      );
    }
    let pageDecremenEllipses = null;
    if (minPageLimit >= 1) {
      pageDecremenEllipses = (
        <li className="page-item" onClick={handleBackButtonClick}>
          &hellip;
        </li>
      );
    }
    return (
      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-muted">{paginationText}</p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
              aria-disabled={previosDisabled}
              aria-label="previous page"
              pagerangedisplayed={10}
            >
              «
            </button>
          </li>
          {pageDecremenEllipses}
          {pageNumbers}
          {pageIncrementEllipses}
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
              aria-disabled={nextDisabled}
              aria-label="next page"
            >
              »
            </button>
          </li>
        </ul>
      </div>
    );
  };
  /* END DATATABLE */
  const CustomLoader = () => (
    <div style={{ padding: "24px" }}>
      <DivLoader color="primary" />
    </div>
  );
  return (
    <>
      <Loading
        loading={fullLoading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
      <HeaderSection
        title="Manage"
        heading="Comments"
        //addButton={() => handleShow("Add", 0)}
        addLink={CONST.ADMIN_PRE + "techQuestionAnwser/"+technologyId}
        addLinkName="Back to Question list"
        linktype="add"
      />
      {/* <Link to={CONST.ADMIN_PRE + "techQuestionAnwser/"+technologyId}>
        Back to Question list
      </Link> */}
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Select version</h3>
                    <div>
                  <select
                      className="form-select form-control"
                      name="versions"
                      id="versions"
                      placeholder="Select version"
                      onChange={(e) => handleOnchange(e.target.value)}
                     // value={techVersion}
                     >
                      <option>Select version</option>
                      { Object.keys(dbVersionValue).map((el,index) => {
                        return (
                          <>
                            <option key={`version_id_+${dbVersionValue[el].id}`} value={dbVersionValue[el].id}>
                              {dbVersionValue[el].value}
                            </option>
                          </>
                        )
                        }) }
                    </select>
                  </div>
                 
                </div>

                {/* <div className="card-body border-bottom py-3">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label required">Status</label>
                        <select
                          className="form-select form-control"
                          name="searchQuestionStatus"
                          id="searchQuestionStatus"
                          placeholder="Select status"
                          onChange={(e) =>
                            setsearchQuestionStatus(e.target.value)
                          }
                          value={searchQuestionStatus}
                        >
                          {" "}
                          <option value="">Select</option>
                          <option value="1">Active</option>
                          <option value="0">Deactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group mb-3 ">
                        <label className="form-label">&nbsp;</label>
                        <div>
                          <button
                            type="button"
                            name="btnSearch"
                            id="btnSearch"
                            className="btn btn-blue d-none d-sm-inline-block ml-3"
                            onClick={questionSearch}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon icon-tabler icon-tabler-search"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <circle cx="10" cy="10" r="7"></circle>
                              <line x1="21" y1="21" x2="15" y2="15"></line>
                            </svg>
                            Search
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            name="btnReset"
                            id="btnReset"
                            className="btn btn-outline-primary "
                            onClick={clearSearch}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon icon-tabler icon-tabler-x"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                    pagination="true"
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>
                <div className="card-footer d-flex align-items-center">
                  <p className="m-0 text-muted">
                    Showing {/* <span>1</span> to <span>8</span> of{" "} */}
                    <span>{totalRecords}</span> entries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{action} Question and Answer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form method="POST" onSubmit={handleSubmit} autoComplete={"off"}>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label required">Version</label>
                <MultiSelect
                  defaultValue={versionValue}
                  onChange={handleOnchange}
                  options={allTechVersions}
                  className={`${
                    validate.validate && validate.validate.allTechVersions
                      ? "is-invalid "
                      : ""
                  }`}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label required">Question</label>
                <div>
                  <textarea
                    name="questionTitle"
                    id="questionTitle"
                    className={`form-control ${
                      validate.validate && validate.validate.questionTitle
                        ? "is-invalid "
                        : ""
                    }`}
                    aria-describedby=""
                    placeholder="Enter Technology Question"
                    onChange={(e) => setQuestionTitle(e.target.value)}
                    value={questionTitle}
                  ></textarea>
                </div>
              </div>

              <div className="col-md-12">
                <label className="form-label required">Description</label>
                <div>
                  <JoditEditor
                    ref={editor}
                    config={config}
                    value={techDescription}
                    onBlur={(newContent) => setDescription(newContent)}
                    onChange={(newContent) => {}}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label required">Status</label>
                  <select
                    className={`form-select form-control ${
                      validate.validate && validate.validate.status
                        ? "is-invalid "
                        : ""
                    }`}
                    name="status"
                    id="status"
                    placeholder="Select status"
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}>
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Deactive</option>
                  </select>
                </div>
              </div>
            </div>
            <input
              type="hidden"
              name="questionId"
              id="questionId"
              value={questionId}
            />
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}


      <Modal size="lg" show={addReplyPopupShow} onHide={closeReplyPopup}>
        <Modal.Header closeButton>
          <Modal.Title> Add reply </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form method="POST" onSubmit={submitReply} autoComplete={"off"}>
            <div className="row">
          
              <div className="col-md-12">
                <label className="form-label required">Add your reply here</label>
                <div>
                  <textarea
                    name="commentReply"
                    id="commentReply"
                    className={`form-control ${
                      validate.validate && validate.validate.commentReply
                        ? "is-invalid "
                        : ""
                    }`}
                    aria-describedby=""
                    placeholder="Enter The Reply"
                    onChange={(e) => setCommentReply(e.target.value)}
                    value={commentReply}
                  ></textarea>
                </div>
              </div>

           
            </div>
           
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeReplyPopup}>
            Close
          </Button>
          <Button variant="primary" onClick={submitReply}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={listReplyPopupShow} onHide={closeListReplyPopup}>
        <Modal.Header closeButton>
          <Modal.Title> Reply List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <table className="table table-vcenter card-table">
        <thead>
            <tr>
                <th>Name</th>
                <th>Title</th>
            </tr>
        </thead>
        <tbody>

        {replyList.length
              ? replyList.map((rData, index) => {
                  return (
                    <>
                      <tr>
                      {rData.commentData['name']}
                        {/* { rData.commentData.map(d,{
                          return ( <>
                            <td>{d.name}</td></>
                          )
                        })} */}
                        <td className="text-secondary">
                        {rData.reply}
                        </td>
                    </tr>
                    </>
                  );
                })
              : ""}
            
        </tbody>
        </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeListReplyPopup}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={submitReply}>
            Submit
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default QuestionCommentList;